import { render, staticRenderFns } from "./mycard.vue?vue&type=template&id=1e639c72&scoped=true&"
import script from "./mycard.vue?vue&type=script&lang=js&"
export * from "./mycard.vue?vue&type=script&lang=js&"
import style0 from "./mycard.vue?vue&type=style&index=0&id=1e639c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e639c72",
  null
  
)

export default component.exports